import React from "react";
import styled from "styled-components/native";

const Label = styled.Text`
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => props.fontSize || props.theme.fontSize}px;
  font-weight: ${props => props.fontWeight || props.theme.fontWeight || "normal"};
  color: ${props => props.color || props.theme.fontColor};
  margin: ${props => props.margins || 0};
  text-decoration-line: ${props => props.textdecorationline || "none"};
  ${props => props.textdecorationline && `text-decoration-color: ${props.textdecorationcolor || props.color || props.theme.fontColor};`}
  ${props => props.textdecorationline && `text-decoration-style: ${props.textdecorationstyle || "solid"};`}
`;

/* Label that makes the text not selectable */
export default props => <Label {...props} selectable={false} />;
